import { render, staticRenderFns } from "./listClinicCustomers.vue?vue&type=template&id=85603454&scoped=true&"
import script from "./listClinicCustomers.vue?vue&type=script&lang=js&"
export * from "./listClinicCustomers.vue?vue&type=script&lang=js&"
import style0 from "./listClinicCustomers.vue?vue&type=style&index=0&id=85603454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85603454",
  null
  
)

export default component.exports